export default __webpack_public_path__ + "static/media/developer-picturemark-l.08360910.svg";